import React from 'react'

import { ArrowDropDown } from '@material-ui/icons'

import { ButtonPopover, ButtonPopoverProps, RoundedPlainTextButton } from '@percept/mui'

import { OrgUnitTree, OrgUnitTreeProps } from './OrgUnitTree'


export type OrgUnitTreePopoverProps = (
  Omit<OrgUnitTreeProps, 'onNodeClick'>
  & Pick<ButtonPopoverProps, 'disabled' | 'buttonContent' | 'ButtonComponent' | 'variant' | 'size'>
)

export const OrgUnitTreePopover = ({
  buttonContent,
  ButtonComponent = RoundedPlainTextButton,
  disabled,
  variant = 'contained',
  size = 'small',
  ...props
}: OrgUnitTreePopoverProps): JSX.Element => {

  return (
    <ButtonPopover
      buttonContent={buttonContent}
      disabled={disabled}
      ButtonComponent={ButtonComponent}
      variant={variant}
      size={size}
      endIcon={<ArrowDropDown />}>
      { ({ onClose }): JSX.Element => {
        return (
          <OrgUnitTree
            {...props}
            onNodeClick={onClose} />
        )
      }}
    </ButtonPopover>
  )
}
